<template>
  <div>
    <beast-header/>
    <div class="container">
      <div class="row">
        <div class="alert col-12" :class="`alert-${alertStatus}`" v-if="alertMessage" v-text="alertMessage"></div>
        <div class="col-6">
          <h1>Editing Profile</h1>
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-4">
                  <img :src="`https://www.gravatar.com/avatar/${me.gravatarHash}?s=150`" class="img-fluid"/>
                </div>
                <div class="col-8">
                  <div class="form-group">
                    <label>First Name</label>
                    <input type="text" class="form-control" name="firstName" v-model="me.firstName"/>
                  </div>
                  <div class="form-group">
                    <label>Last Name</label>
                    <input type="text" class="form-control" name="lastName" v-model="me.lastName"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button class="btn btn-success float-right" @click="saveInfo">
                Save
              </button>
              <button class="btn btn-outline-secondary float-right beast-buttons" @click="refreshData('info')">
                Discard changes
              </button>
            </div>
          </div>
        </div>
        <div class="col-6 beast-enp">
          <h3>Email &amp; Password</h3>
          <div class="card">
            <div class="card-body">
              <div class="form-group">
                <label>Email</label>
                <input type="text" class="form-control" v-model="me.email" :readonly="readOnlyMail"/>
              </div>
            </div>
            <div class="card-footer">
              <button class="btn btn-success" v-if="readOnlyMail" @click="enableMail">
                Change Email
              </button>

              <button class="btn btn-success float-right"
                      @click="saveMail"
                      v-if="!readOnlyMail">
                Save
              </button>
              <button class="btn btn-outline-secondary float-right beast-buttons"
                      @click="refreshData('email')"
                      v-if="!readOnlyMail">
                Discard changes
              </button>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="form-group">
                <label>Current Password</label>
                <input type="password" class="form-control" v-model="currentPassword"/>
              </div>
              <div class="form-group">
                <label>Password</label>
                <input type="password" class="form-control" v-model="password"/>
              </div>
              <div class="form-group">
                <label>Confirm Password</label>
                <input type="password" class="form-control" v-model="confirmPassword"/>
              </div>
            </div>
            <div class="card-footer">
              <button class="btn btn-success float-right"
                      @click="savePassword">
                Save
              </button>
              <button class="btn btn-outline-secondary float-right beast-buttons"
                      @click="refreshData('password')">
                Discard changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <beast-footer/>
  </div>
</template>

<script>
import BeastHeader from "../../components/header/BeastHeader.vue";
import BeastFooter from "../../components/footer/BeastFooter.vue";

export default {
  components: {
    BeastFooter,
    BeastHeader
  },
  props: {
    username: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      alertStatus: "success",
      alertMessage: "",
      readOnlyMail: true,
      currentPassword: "",
      password: "",
      confirmPassword: "",
      me: {
        username: ""
      }
    };
  },
  methods: {
    async saveInfo() {
      try {
        await this.axios.put("/profile", this.me);

        this.alertStatus = "success";
        this.alertMessage = "Information has been updated";
        await this.refreshData();
      } catch (e) {
        this.alertStatus = "danger";
        this.alertMessage = this._extractErrors(e);
      } finally {
        setTimeout(() => {
          this.alertMessage = "";
        }, 3500);
      }
    },
    async saveMail() {
      try {
        await this.axios.put("/profile/email", this.me);

        this.alertStatus = "success";
        this.alertMessage = "Information has been updated";
        await this.refreshData();
      } catch (e) {
        this.alertStatus = "danger";
        this.alertMessage = this._extractErrors(e);
      } finally {
        setTimeout(() => {
          this.alertMessage = "";
        }, 3500);
      }
    },
    async savePassword() {
      try {
        await this.axios.put("/profile/password", {
          currentPassword: this.currentPassword,
          password: this.password,
          confirmPassword: this.confirmPassword,
        });

        this.alertStatus = "success";
        this.alertMessage = "Information has been updated";
        await this.refreshData();
      } catch (e) {
        this.alertStatus = "danger";
        this.alertMessage = this._extractErrors(e);
      } finally {
        setTimeout(() => {
          this.alertMessage = "";
        }, 3500);
      }
    },
    async refreshData(section) {
      await this.$auth.fetch();
      const userResponse = await this.$auth.user();
      if (section === null || section === undefined) {
        this.me = userResponse;
        this.setTitle(this.me.username);
      }
      if (section === "email") {
        this.me.email = userResponse.email;
        this.readOnlyMail = true;
      }
      if (section === "password") {
        this.currentPassword = "";
        this.password = "";
        this.confirmPassword = "";
      }
      if (section === "info") {
        this.me.firstName = userResponse.firstName;
        this.me.lastName = userResponse.lastName;
      }
    },
    enableMail() {
      this.readOnlyMail = false;
    },
    _extractErrors(err) {
      if (!err.response || !err.response.data) {
        return err.message;
      }

      return err.response.data.message;
    }
  },
  async beforeMount() {
    await this.refreshData();
    this.$router.replace({
      path: `/profile/${this.me.username}/edit`
    });
  }
};
</script>
<style scoped lang="scss">
  h1, h2, h3, h4 {
    text-transform: uppercase;
  }

  .beast-buttons {
    margin-right: 15px;
  }
  .beast-enp .card {
    margin-bottom: 20px;
  }
</style>
